import { Injectable } from '@angular/core';

@Injectable()
export class ProductDetailCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello Product");
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/pages/product-detail/product-detail.common.ts